import { useLiveUpdates } from '../contexts/updates';
import { STREAM_STATUS } from '../utils/notice';

import '../styles/live-indicator.css';

// Whether the screen is keeping itself up to date, said where the data is.
//
// A board that stopped updating looks exactly like a board where nothing is
// happening. So the state of the channel is on the page: live, reconnecting, or
// fallen back to asking every thirty seconds — and in that last case, a way to
// try the channel again.

const TEXT = {
    [STREAM_STATUS.connecting]: 'Conectando…',
    [STREAM_STATUS.live]:       'En vivo',
    [STREAM_STATUS.retrying]:   'Reconectando…',
    [STREAM_STATUS.down]:       'Reconectando…',
};

export default function LiveIndicator() {
    const live = useLiveUpdates();
    if (!live) return null;

    if (!live.enabled) {
        return (
            <span className="live-indicator live-indicator--off" title="Hace falta events:read para recibir los cambios en vivo">
                <span className="live-indicator__dot" aria-hidden="true" />
                Sin actualización automática
            </span>
        );
    }

    if (live.polling) {
        return (
            <span className="live-indicator live-indicator--polling" role="status">
                <span className="live-indicator__dot" aria-hidden="true" />
                Se actualiza cada 30 s
                <button type="button" className="live-indicator__retry" onClick={live.reconnect}>
                    Volver a conectar
                </button>
            </span>
        );
    }

    const status = live.stream.status;
    return (
        <span
            className={`live-indicator live-indicator--${status}`}
            role="status"
            title={status === STREAM_STATUS.live
                ? 'Los cambios llegan solos: no hace falta recargar'
                : undefined}
        >
            <span className="live-indicator__dot" aria-hidden="true" />
            {TEXT[status] ?? status}
        </span>
    );
}
